<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-29 16:04:17
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:18:52
--> 
<template>
  <!-- 下拉列表组件 -->
  <div>
    <div>
      <v-icon @click.stop="drawer = !drawer" class="material-icons"
        >filter_list</v-icon
      >
    </div>
    <v-btn rounded width="344" height="40" :depressed="true" color="#F5F5F5">
      <div class="d-flex justify-space-between" style="width: 100%">
        <v-icon @click.stop="drawer = !drawer" class="material-icons"
          >filter_list</v-icon
        >
        <div style="flex: 1" class="d-flex align-center">xxxxxx</div>
        <v-icon class="material-icons">close</v-icon>
      </div>
    </v-btn>
    <!-- 功能过滤 -->
    <v-navigation-drawer
      v-model="drawer"
      fixed
      right
      class="bigboxdrawer"
      style="
        font-size: 13px;
        color: rgba(0, 0, 0, 0.78);
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      "
      mini-variant
      mini-variant-width="376"
      temporary
    >
      <div class="dv">
        <span></span>
        <span>
          <v-icon @click.stop="drawer = !drawer" class="material-icons"
            >close</v-icon
          >
        </span>
      </div>

      <v-expansion-panels accordion :flat="true" :tile="true">
        <v-expansion-panel
          v-for="item in list"
          style="border-bottom: 1px solid #e0e0e0"
          :key="item.label"
        >
          <v-expansion-panel-header>
            <div>
              <span class="mr-1">{{ item.label }}</span>
              <span class="smallRound"> xx </span>
              <span>
                <v-icon
                  style="
                    font-size: 16px;
                    color: #739ce8;
                    position: relative;
                    top: -3px;
                  "
                  class="material-icons"
                  >check_circle</v-icon
                >
              </span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <!-- 内容 -->
            <!-- 单选多选 -->
            <template>
              <mrc_ess_yearPicker
                yearDisable="after"
                v-model="year"
              ></mrc_ess_yearPicker>
              <mrc_ess_dateTimePicker
                :type="arrtype"
                @change="change"
              ></mrc_ess_dateTimePicker>
              <mrc_ess_autoComplete
                v-model="item.defaultValue"
              ></mrc_ess_autoComplete>
            </template>
            <!-- 数字类型 -->
            <template v-if="item.type == 4">
              <div v-if="item.multiple == 0">
                <div>高级参照</div>
                <mrc_ess_NumInput
                  v-model="item.defaultValue"
                ></mrc_ess_NumInput>
              </div>
              <div v-else>
                <div>高级参照</div>
                <div class="d-flex justify-space-between">
                  <div style="width: 156px">
                    <mrc_ess_NumInput
                      v-model="item.defaultValue"
                    ></mrc_ess_NumInput>
                  </div>
                  <div style="width: 156px">
                    <mrc_ess_NumInput
                      v-model="item.defaultValue2"
                    ></mrc_ess_NumInput>
                  </div>
                </div>
              </div>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <mrc_ess_submitBtn
        @cancel="cancel"
        style="position: absolute; bottom: 0; background-color: #fff"
        cancelText="Clear"
        successText="Apply"
        :loading="btnloading"
        @success="success"
      ></mrc_ess_submitBtn>
    </v-navigation-drawer>

    <!-- <span v-if="!showMenu"
            @click='showMenu=true'>sasas</span> -->
    <!-- <v-menu offset-y
            v-model="showMenu"
            :disabled='disabled'
            nudge-top='50'
            left
            :close-on-content-click='false'>
      <template v-slot:activator="{ on, attrs }">

      </template>
      <mrc_ess_searchInput></mrc_ess_searchInput>
    </v-menu> -->
  </div>
</template>

<script>
import { weekdaysMin } from "moment";
/**
 * iconShow   是否显示下拉图标
 */
export default {
  components: {},
  props: {
    btnloading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "业务功能",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: [String, Array],
      default: "",
    },
    tableList: {
      default: Array,
      default: () => [
        {
          type: 1,
          label: "测试", //
          icon: 0, //label旁边的图标显示状态类型  现在ui上展示为两种
          defaultValue: "1", //默认值 多选返回数组 defaultValue:[]
          selectList: [
            {
              uuid: "1111313155454",
              name: "xaxa",
            },
          ], //下拉列表
          multiple: false, //多选or单选
          disabled: false, //禁用状态
          placeholder: "请选择下拉选择", //默认显示值
        },
      ],
    },
  },
  model: {
    prop: "uuid",
    event: "change",
  },
  data() {
    return {
      drawer: null,
      showMenu: false,
      list: [],
      arrtype: "date",
      defaultTime: "",
      year: "2014",
    };
  },
  computed: {},
  created() {},
  watch: {},
  mounted() {
    this.tableList.map((item) => {
      this.list.push(item);
    });
  },

  methods: {
    change(v, v2) {
      // this.defaultTime = v
    },
    cancel() {
      this.$emit("cancel");
    },
    success() {
      this.$emit("success");
      this.drawer = false;
    },
  },
};
</script>

<style scoped>
.dv {
  min-height: 56px;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 24px;
  justify-content: space-between !important;
  align-items: center;
  display: flex;
}
.smallRound {
  display: inline-block;
  line-height: 12px;
  text-align: center;
  font-size: 12px;
  width: 14px;
  height: 14px;
  color: #ffffff;
  background: #739ce8;
  border-radius: 50%;
  position: relative;
  top: -3px;
}
</style>
